import { render, staticRenderFns } from "./questionCardSwiper.vue?vue&type=template&id=2fc4340e&scoped=true"
import script from "./questionCardSwiper.vue?vue&type=script&lang=js"
export * from "./questionCardSwiper.vue?vue&type=script&lang=js"
import style0 from "./questionCardSwiper.vue?vue&type=style&index=0&id=2fc4340e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc4340e",
  null
  
)

export default component.exports